export const BREADCRUMBS_SET = 'ui/breadcrumbs_set';
export const BREADCRUMBS_CLEAR = 'ui/breadcrumbs_clear';

export function setBreadcrumbs(breadcrumbs = []) {
  return dispatch => {
    dispatch({
      type: BREADCRUMBS_SET,
      payload: breadcrumbs,
    });
  };
}

export function clearBreadcrumbs() {
  return dispatch => {
    dispatch({
      type: BREADCRUMBS_CLEAR,
    });
  };
}
